import { useEffect } from 'react';
import { useFlow } from '../hooks/useFlow';
import { useReceptionInfo } from '../hooks/useReceptionInfo';
import Layout from './Layout';
import Call from './Call';
import { ClinicProps } from '../types/Props';

const PAGE_TRANSITION_DELAY_MS = 3000;

function Finished({ clinicName }: ClinicProps) {
  const { setFlow } = useFlow();
  const { receptionNumber, receptionName } = useReceptionInfo();
  useEffect(() => {
    setTimeout(() => {
      setFlow('top');
    }, PAGE_TRANSITION_DELAY_MS);
  }, []);

  return (
    <Layout flowName="受付完了" clinicName={clinicName || undefined}>
      <div className="grid place-items-center mt-8 text-2xl font-bold text-gray-500">
        <p className="mt-14">
          {receptionNumber} {receptionName}様
        </p>
        <p className="mt-8">受付を完了しました。</p>
        <p className="mt-16">ご案内があるまでお待ちください。</p>
      </div>
      <Call className="mt-14" />
    </Layout>
  );
}

export default Finished;
